<template>
  <!-- 月度指标 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">水质监测栏目</span>
    </div>
    <div class="main">
      <div class="headerUnit">
        <span style="flex-grow: 2">位置</span>
        <span style="flex-grow: 1">时间</span>
        <span style="flex-grow: 1">浊度NTU</span>
        <span style="flex-grow: 1">温度℃</span>
        <span style="flex-grow: 2">PH</span>
      </div>
      <div class="dataWrap">
        <div class="rawWater">
          <img src="~@/assets/myImg/1/h_1_gs.png" />
          <span>原水</span>
        </div>
        <div class="tableItem" style="background: rgba(103, 169, 255, 0.15)" v-for="item in rawWaterList"
          :key="getTransactionID()">
          <div style="flex-grow: 2" class="tableItemDiv">
            <a-tooltip>
              <template slot="title">{{ item.address }}</template>
              {{ item.address }}
            </a-tooltip>
          </div>
          <span style="flex-grow: 1">{{ item.time }}</span>
          <span style="flex-grow: 1">{{ item.turbidity }}</span>
          <span style="flex-grow: 1">{{ item.chlorine }}</span>
          <span style="flex-grow: 1">{{ item.ph }}</span>
        </div>

        <!-- 出厂水 -->
        <div class="rawWater">
          <img src="~@/assets/myImg/1/h_1_gs.png" />
          <span>出厂水</span>
        </div>
        <div class="dataWrapBox" id="dataWrapBox" @scroll.prevent>
          <div class="ulDivMC" id="ulDivMC" @scroll.prevent>
            <div @scroll.prevent class="tableItem" style="background: rgba(0, 235, 238, 0.15)"
              v-for="item in FactoryWaterList" :key="getTransactionID()">
              <div style="flex-grow: 2" class="tableItemDiv">
                <a-tooltip>
                  <template slot="title">{{ item.address }}</template>
                  {{ item.address }}
                </a-tooltip>
              </div>
              <span style="flex-grow: 1">{{ item.time }}</span>
              <span style="flex-grow: 1">{{ item.turbidity }}</span>
              <span style="flex-grow: 1">{{ item.chlorine }}</span>
              <span style="flex-grow: 1">{{ item.ph }}</span>
            </div>
          </div>
        </div>
        <div class="headerUnit">
          <span style="flex-grow: 2">位置</span>
          <span style="flex-grow: 1">时间</span>
          <span style="flex-grow: 1">浊度NTU</span>
          <span style="flex-grow: 1">余氯mg/L</span>
          <span style="flex-grow: 2">PH</span>
        </div>
        <!-- 管末端梢水 -->
        <div class="rawWater">
          <img src="~@/assets/myImg/1/h_1_gs.png" />
          <span>管末端梢水</span>
        </div>
        <div class="dataWrapBoxtwo" id="TipWater" @scroll.prevent>
          <div class="ulDivMC" id="ulDivTipWater" @scroll.prevent>
            <div @scroll.prevent class="tableItem" style="background: rgba(0, 42, 245, 0.15)"
              v-for="item in TipWaterList" :key="getTransactionID()">
              <div class="tableItemDiv">
                <a-tooltip>
                  <template slot="title">{{ item.address }}</template>
                  {{ item.address }}
                </a-tooltip>
              </div>
              <span style="flex-grow: 1">{{ item.time }}</span>
              <span style="flex-grow: 1">{{ item.turbidity }}</span>
              <span style="flex-grow: 1">{{ item.chlorine }}</span>
              <span style="flex-grow: 1">{{ item.ph }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MonitoringColumn',
  components: {},
  data() {
    return {
      speed: 50,
      roll: '',
      roll1: '',
      roll2: '',
      TipWater: '',
      TipWater1: '',
      TipWater2: '',
      rawWaterList: [],
      FactoryWaterList: [],
      TipWaterList: [],
      minuteTimer: null,
      scrollInterval1: null,
      scrollInterval2: null
    }
  },
  computed: {
    ...mapState({
      modbusObj: state => state.app.modbusObj
    })
  },
  mounted() {
    this.setupMinuteTimer();
    this.getList(); // Initial call
  },
  beforeDestroy() {
    clearInterval(this.scrollInterval1);
    clearInterval(this.scrollInterval2);
    clearTimeout(this.minuteTimer);
  },
  methods: {
    getTransactionID() {
      return "" + this.getCurrentTime() + this.getRandom();
    },
    getCurrentTime() {
      return new Date().valueOf();
    },
    getRandom() {
      return Math.floor(Math.random() * 10) * 1000 +
        Math.floor(Math.random() * 10) * 100 +
        Math.floor(Math.random() * 10) * 10 +
        Math.floor(Math.random() * 10);
    },
    setupMinuteTimer() {
      const now = new Date();
      const secondsUntilNextMinute = 60 - now.getSeconds();

      // Set timeout to align with the next full minute
      this.minuteTimer = setTimeout(() => {
        this.getList(); // Execute immediately at the full minute
        // Then set up the regular interval
        this.minuteTimer = setInterval(() => {
          this.getList();
        }, 60000); // 60,000ms = 1 minute
      }, secondsUntilNextMinute * 1000);
    },
    getList() {
      this.$http.get('/pipe-network/water_quality/screen-quality').then((res) => {
        this.rawWaterList = res.data[0].result;
        this.FactoryWaterList = res.data[1].result;
        this.TipWaterList = res.data[2].result;

        // Clear existing scroll intervals
        if (this.scrollInterval1) clearInterval(this.scrollInterval1);
        if (this.scrollInterval2) clearInterval(this.scrollInterval2);

        if (this.FactoryWaterList.length > 1) {
          this.FactoryWaterList = this.FactoryWaterList.concat(this.FactoryWaterList);
          this.$nextTick(() => {
            this.goScroll();
          });
        }
        if (this.TipWaterList.length > 1) {
          this.TipWaterList = this.TipWaterList.concat(this.TipWaterList);
          this.$nextTick(() => {
            this.goScrolltwo();
          });
        }
      }).catch(error => {
        console.error('Error fetching water quality data:', error);
      });
    },
    goScroll() {
      this.roll1 = document.getElementById('ulDivMC');
      this.roll = document.getElementById('dataWrapBox');

      // Clear previous interval if exists
      if (this.scrollInterval1) clearInterval(this.scrollInterval1);

      this.scrollInterval1 = setInterval(this.Marquee1, this.speed);

      this.roll.onmouseover = () => {
        clearInterval(this.scrollInterval1);
      };

      this.roll.onmouseout = () => {
        this.scrollInterval1 = setInterval(this.Marquee1, this.speed);
      };
    },
    Marquee1() {
      const roll1Offset = this.FactoryWaterList.length * 30 / 2;
      if (this.roll.scrollTop >= roll1Offset) {
        this.roll.scrollTop = 0;
      } else {
        this.roll.scrollTop++;
      }
    },
    goScrolltwo() {
      this.TipWater1 = document.getElementById('ulDivTipWater');
      this.TipWater = document.getElementById('TipWater');

      // Clear previous interval if exists
      if (this.scrollInterval2) clearInterval(this.scrollInterval2);

      this.scrollInterval2 = setInterval(this.Marquee2, this.speed);

      this.TipWater.onmouseover = () => {
        clearInterval(this.scrollInterval2);
      };

      this.TipWater.onmouseout = () => {
        this.scrollInterval2 = setInterval(this.Marquee2, this.speed);
      };
    },
    Marquee2() {
      const roll1Offset = this.TipWaterList.length * 30 / 2;
      if (this.TipWater.scrollTop >= roll1Offset) {
        this.TipWater.scrollTop = 0;
      } else {
        this.TipWater.scrollTop++;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 294px;
  width: 540px;
  background: url(~@/assets/myImg/h_9_szzjlm_box.png) no-repeat;
  background-size: cover;
  position: relative;

  .img-title {
    position: absolute;
    position: relative;
    bottom: 18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      width: 264px;
      height: 40px;
    }
  }

  .main {
    position: absolute;
    top: 30px;
    height: 220px;
    width: 100%;

    .headerUnit {
      padding: 0 10px;
      width: 100%;
      height: 30px;
      background-image: linear-gradient(270deg, rgba(7, 42, 80, 0.35) 0%, rgba(84, 169, 255, 0.25) 100%);
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      text-align: center;

      span {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 15px;
        color: #15a9f1;
        font-weight: 600;
      }
    }

    .dataWrap {
      height: 233px;
      width: 100%;
      padding: 0 10px;
      padding-bottom: 10px;
      overflow-x: hidden;
      overflow-y: auto;

      .rawWater {
        width: 100%;
        height: 40px;
        padding: 0 6px;
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
        }

        span {
          font-family: MicrosoftYaHeiSemibold;
          font-size: 16px;
          color: #00ebee;
          font-weight: 600;
          margin-left: 8px;
        }
      }

      .tableItem {
        width: 100%;
        min-height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        text-align: center;

        .tableItemDiv {
          min-width: 40px;
          max-width: 60px;
          font-family: MicrosoftYaHeiSemibold;
          font-size: 15px;
          color: #ffffff;
          font-weight: 600;

          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        span {
          display: inline-block;
          min-width: 40px;
          max-width: 60px;
          font-family: MicrosoftYaHeiSemibold;
          font-size: 15px;
          color: #ffffff;
          font-weight: 600;
          overflow: hidden;
        }
      }
    }

    /*全局滚动条样式*/
    .dataWrap::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    .dataWrap::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.35);
      border-radius: 5px;
    }

    .dataWrap::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.05);
      border-radius: 4px;
    }
  }
}

.dataWrapBox,
.dataWrapBoxtwo {
  height: 30px;
  overflow-x: hidden;
}

.ulDivMC {
  height: 100%;
}

.dataWrapBox::-webkit-scrollbar,
.dataWrapBoxtwo::-webkit-scrollbar,
.dataWrap::-webkit-scrollbar {
  width: 0 !important;
}

.dataWrapBox,
.dataWrapBoxtwo,
.dataWrap {
  -ms-overflow-style: none;
}

.dataWrapBox,
.dataWrapBoxtwo,
.dataWrap {
  overflow: -moz-scrollbars-none;
}
</style>